module.exports = __webpack_public_path__ + "static/img/cont43_06.b9feb53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_06.jpg
// module id = qAa2
// module chunks = 0